import React, { useState } from 'react';
import ChangePasswordForm from './ChangePasswordForm';
import './ChangePassword.css';

/** Header "Change password" modal — available to every signed-in care user. */
export default function ChangePasswordModal({ open, onClose }) {
  const [done, setDone] = useState(false);
  if (!open) return null;

  return (
    <div className="cp-modal-overlay" onClick={onClose} role="presentation">
      <div className="cp-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cp-modal-header">
          <h2>Change password</h2>
          <button type="button" className="cp-modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        {done ? (
          <div className="cp-success" role="status">
            <p>Your password has been changed.</p>
            <button type="button" className="cp-submit" onClick={onClose}>Close</button>
          </div>
        ) : (
          <ChangePasswordForm onSuccess={() => setDone(true)} />
        )}
      </div>
    </div>
  );
}
